import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Authenticate } from '../models/auth/authenticate';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class ThemesService {
    public static readonly DARK_THEME = 'avm-dark-theme';
    public static readonly LIGHT_THEME = 'avm-light-theme';

    private currentTheme: BehaviorSubject<string>;

    public get currentTheme$() {
        return this.currentTheme.asObservable();
    }

    currentUserChange: Subscription;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private memoryService: MemoryService
    ) {
        let defaultTheme = localStorage.getItem('theme');

        if (!defaultTheme) {
            defaultTheme = ThemesService.DARK_THEME;
        }

        this.currentTheme = new BehaviorSubject(defaultTheme);

        this.currentUserChange = memoryService.connectedUserChange.subscribe((currentUser) => {
            if (currentUser) {
                this.changeTheme(this.getUserTheme(currentUser), false);
            }
        });
    }

    changeTheme(theme: string = null, isManual: boolean) {
        switch (theme) {
            case ThemesService.DARK_THEME:
                document.body.classList.add(ThemesService.DARK_THEME);
                document.body.classList.remove(ThemesService.LIGHT_THEME);
                break;

            case ThemesService.LIGHT_THEME:
                document.body.classList.add(ThemesService.LIGHT_THEME);
                document.body.classList.remove(ThemesService.DARK_THEME);
                break;

            default:
                theme = ThemesService.DARK_THEME;
                document.body.classList.add(ThemesService.DARK_THEME);
                document.body.classList.remove(ThemesService.LIGHT_THEME);
                break;
        }

        this.currentTheme.next(theme);

        if (isManual) {
            localStorage.setItem('theme', theme);
        }
    }

    getCurrentTheme() {
        return this.currentTheme.value;
    }

    getUserTheme(user: Authenticate): string {
        let userTheme: string;

        if (localStorage.getItem('theme')) {
            userTheme = localStorage.getItem('theme');
        } else if (user.uiTheme) {
            userTheme = user.uiTheme === 'light' ? ThemesService.LIGHT_THEME : user.uiTheme === 'dark' ? ThemesService.DARK_THEME : ThemesService.DARK_THEME;
        }

        return userTheme;
    }
}
